import AuthService from 'services/auth'
import { useNavigate } from 'react-router-dom'

export default function Favorites () {

}